import ART_COLLECTION_NAV from '@lib/const/art-collection-nav.const'
import { CollectionsAndArchiveTemplate } from '@templates'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { CollectionsService, PageService } from '@services'
import { ISSRPageData } from '@interfaces'

const ArtArchivesScreen = ({ pageData, global }: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath, pathname } = useRouter()
  const hero = pageData.hero

  return (
    <CollectionsAndArchiveTemplate
      global={global}
      pageTitle={
        hero?.pageTitle || t('collections-and-research:archives.title')
      }
      pathname={pathname}
      asPath={asPath}
      heroBgImageUrl={
        hero?.bgImageUrl ||
        'https://drupal.sakipsabancimuzesi.org/sites/muze.sabanciuniv.edu/files/2021-10/arsivler-bnr.jpg'
      }
      heroBgImageUrlMobile={hero?.bgImageUrlMobile}
      heroSubTitle={
        hero?.subTitle ||
        t('collections-and-research:archives.banner.subTitle')
      }
      heroTitle={
        hero?.title || t('collections-and-research:archives.banner.title')
      }
      heroDescription={
        hero?.description ||
        t('collections-and-research:archives.banner.description')
      }
      artCollectionNav={ART_COLLECTION_NAV}
      activePage="archive"
      artCollectionData={pageData.data}
    />
  )
}

export default ArtArchivesScreen

export async function getStaticProps({ locale }) {
  const pageData = {
    data: null,
    hero: null,
    error: null,
  }

  try {
    const [collections, drupalPage] = await Promise.all([
      CollectionsService.getCollectionsByPageType(locale, 'archive'),
      PageService.getPage(locale, 'archives'),
    ])

    pageData.data = collections

    if (drupalPage) {
      const heroAndPageTitle =
        await PageService.preparePageTitleHeroAnd(drupalPage)

      pageData.hero = {
        pageTitle: heroAndPageTitle.pageTitle,
        ...heroAndPageTitle.hero,
        bgImageUrl:
          drupalPage?.field_page_banner_image?.[0]?.url ||
          heroAndPageTitle.hero.bgImageUrl,
        bgImageUrlMobile:
          drupalPage?.field_page_banner_image_mobile?.[0]?.url ||
          heroAndPageTitle.hero.bgImageUrlMobile,
      }
    }
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  return {
    props: { pageData },
  }
}
